import { UpdatePatientDataPointRes } from "./Model";

// Patient Demographics Loading State
export const PATIENT_SEARCH_LOADING = "PATIENT_SEARCH_LOADING";
export const PATIENT_SEARCH_SUCCESS = "PATIENT_SEARCH_SUCCESS";
export const PATIENT_SEARCH_FAIL = "PATIENT_SEARCH_FAIL";
export const PATIENT_SEARCH_DATA = "PATIENT_SEARCH_DATA";
export const PATIENT_SEARCH_UPDATE_API_MSG = "PATIENT_SEARCH_UPDATE_API_MSG";
export const PATIENT_SEARCH_UPDATE_API_RES = "PATIENT_SEARCH_UPDATE_API_RES";

export interface UpdatePatientDataPointState {
  updatePatientDataPointRes: UpdatePatientDataPointRes;
  loading: boolean;
  message: string;
  status: number;
}
export interface UpdatePatientDataPointLoading {
  type: typeof PATIENT_SEARCH_LOADING;
  loading: boolean;
}
export interface UpdatePatientDataPointSuccess {
  type: typeof PATIENT_SEARCH_SUCCESS;
  payload: UpdatePatientDataPointRes;
}
export interface UpdatePatientDataPointFail {
  type: typeof PATIENT_SEARCH_FAIL;
  payload: UpdatePatientDataPointRes;
  message: string;
  status: number;
}
export interface UpdatePatientDataPointUpdateAPIMsg {
  type: typeof PATIENT_SEARCH_UPDATE_API_MSG;
  payload: UpdatePatientDataPointRes;
  message: string;
  status: number;
}
export interface UpdatePatientDataPointUpdateAPIRes {
  type: typeof PATIENT_SEARCH_UPDATE_API_RES;
  payload: UpdatePatientDataPointRes;
  message: string;
  status: number;
}
interface UpdatePatientDataPointAction {
  type: typeof PATIENT_SEARCH_DATA;
  payload: UpdatePatientDataPointRes;
}

export type UpdatePatientDataPointActionTypes =
  | UpdatePatientDataPointAction
  | UpdatePatientDataPointLoading
  | UpdatePatientDataPointSuccess
  | UpdatePatientDataPointFail
  | UpdatePatientDataPointUpdateAPIMsg
  | UpdatePatientDataPointUpdateAPIRes;
